export default __webpack_public_path__ + "static/1987-98d57ff3185afc27b1c9c42804a2c902.gif";